import { useMemo, useState } from "react";
import { Line } from "../types";
import { scaleBand, scaleLinear } from "d3";
import { YAxis } from "../components/axis/yAxis";
import { XAxis } from "../components/axis/xAxis";
import InfoIcon from '@mui/icons-material/Info';


type DataComparison = {
    x: string,
    y: number,
    color: string
}[]

export const MARGINS = { top: 20, bottom: 50, left: 60, right: 50 }

export function BarForEachMonth({ currentBests, currentYear }: { currentBests: Line, currentYear: Line }) {


    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    const currentYearString = new Date().getFullYear().toString();
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const width = 500;
    const svgHeight = 400;

    const yMax = 120000;

    const dataForCurrentMonth: DataComparison = useMemo(() => {
        console.log("Current year: ", currentYear);
        const best = currentBests?.dataPoints[currentMonth];
        const year = currentYear?.dataPoints[currentMonth];

        return [{
            x: 'Melhor',
            y: best.y,
            color: currentBests.metadata.color
        },
        {
            x: currentYearString,
            y: year.y,
            color: currentYear.metadata.color
        }]
    }, [currentMonth])

    const xScale = scaleBand()
        .domain(['Melhor', currentYearString]) // Pass the array of strings as the domain
        .range([MARGINS.left * 2.4, width - MARGINS.right]) // Set the range of the scale to fit within the SVG width
        .padding(0.2);

    const yScale =
        scaleLinear()
            .domain([yMax, 0])
            .range([MARGINS.top, svgHeight - MARGINS.bottom]);



    return (
        <div className=" border rounded-xl shadow-md w-[800px]">
            <div className="bg-red-300 p-2 rounded-t-xl flex items-center justify-between">
                <h1 className='font-bold pl-5 pb-1'>{'Comparação entre meses'}</h1>
                <InfoIcon className="ml-2 text-blue-500" style={{
                    fontSize: '1.3em'
                }} />
            </div>


            <div>
                <div className="flex justify-center">
                    <span className="font-bold">{meses[currentMonth]}</span>

                </div>
                <svg width={width} height={svgHeight} >
                    <YAxis margins={MARGINS} yScale={yScale} chartDimensions={{ height: svgHeight, width: width }} tickFormattingFunction={(tickVal: number) => tickVal.toString() + ('')} />
                    <XAxis margins={MARGINS} xScale={xScale} yPosition={svgHeight - MARGINS.bottom} tickFormattingFunction={(v: number) => v.toString()} />

                    <g>
                        {dataForCurrentMonth?.map((d, idx) => {
                            return (
                                <rect
                                    key={d.x}
                                    x={(xScale(d.x) || 0) - xScale.bandwidth() / 2}
                                    y={yScale(d.y)}
                                    width={xScale.bandwidth()}
                                    height={yScale(0) - yScale(d.y)}
                                    fill={d.color}
                                />
                            )
                        })}
                    </g>
                </svg>

                <div className="flex items-center px-6 justify-between">
                    <button className="shadow-md p-2 rounded-md bg-cyan-700 text-white text-sm font-bold" onClick={() => currentMonth > 0 ? setCurrentMonth((cm) => cm - 1) : null}>Anterior</button>

                    <button className="shadow-md p-2 rounded-md bg-cyan-700 text-white text-sm font-bold" onClick={() => currentMonth < 11 ? setCurrentMonth((cm) => cm + 1) : null}>Próximo</button>
                </div>
            </div>

        </div>


    )


}